import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DtpAccordionPanel, DtpAccordionGroup } from 'dtp-react-components';
import { Input, Grid, Button } from '../../components';
import Masks from '../../utils/masks';
// import { trataMensagensErro } from '../../utils/requests';
import {
  situacaoCTC,
} from '../../utils/listsSelect';

class FiltroRepositorioCtc extends Component {
  constructor() {
    super();

    this.filtroRepositorioCtc = JSON.parse(sessionStorage.getItem('filtroRepositorioCtc'));
    this.state = {
      cpf: this.filtroRepositorioCtc && this.filtroRepositorioCtc.cpf ? this.filtroRepositorioCtc.cpf : null,
      versaoAtiva: this.filtroRepositorioCtc && this.filtroRepositorioCtc.versaoAtiva !== null ? this.filtroRepositorioCtc.versaoAtiva : 1,
      cliqueiNoBotao: this.filtroRepositorioCtc && this.filtroRepositorioCtc.cliqueiNoBotao ? this.filtroRepositorioCtc.cliqueiNoBotao : 0,
      tipoPesquisa: this.filtroRepositorioCtc && this.filtroRepositorioCtc.tipoPesquisa ? this.filtroRepositorioCtc.tipoPesquisa : null,
    };
  }

  componentDidMount() {
    if (sessionStorage.getItem('filtroRepositorioCtc') &&
      this.state.tipoPesquisa === this.getTipoConsulta()) {
      this.handleSearchButton();
    }
  }

  componentDidUpdate(prevProps) {
    // Apenas repete consulta se parametro da url for alterado
    if (this.props.tipoConsulta !== prevProps.tipoConsulta) {
      this.preparaNovaConsulta();
    }
  }

  getTipoConsulta = () => (
    this.props.tipoConsulta ?
      this.props.tipoConsulta : 'consulta'
  )

  preparaNovaConsulta = () => {
    let filtroRepositorioCtc = {
      cpf: null,
      versaoAtiva: null,
      tipoPesquisa: this.getTipoConsulta(),
    };
    filtroRepositorioCtc = JSON.stringify(filtroRepositorioCtc);
    sessionStorage.setItem('filtroRepositorioCtc', filtroRepositorioCtc);

    this.setState({
      cpf: null,
      versaoAtiva: null,
    });
  }

  handleChange = (changeObj, name) => {
    let callback = null;
    if (name === 'cpf' || name === 'nome') {
      callback = this.props.handleChange(changeObj.value, name);
    }
    this.setState({
      [name]: changeObj.value,
    }, callback);
  }

  handleKeyDown = (e) => {
    let retorno = null;
    if (e.keyCode === 13) {
      retorno = this.handleSearchButton();
    }
    return retorno;
  }

  handleSearchButton = () => {
    let filtroRepositorioCtc = {
      cpf: this.state.cpf,
      versaoAtiva: this.state.versaoAtiva,
      tipoPesquisa: this.getTipoConsulta(),
    };
    filtroRepositorioCtc = JSON.stringify(filtroRepositorioCtc);
    sessionStorage.setItem('filtroRepositorioCtc', filtroRepositorioCtc);
    this.setState(
      {
        cliqueiNoBotao: 1,
      },
      () => {
        this.handleChange({
          value: 1,
          isValid: true,
        }, 'cliqueiNoBotao');
      },
    );
    this.handleSearch();
  }

  handleSearch = () => {
    let paramCpf = '';
    if (this.state.cpf) {
      paramCpf = this.state.cpf.toUpperCase();
      if (this.state.cpf.indexOf('_') !== -1) {
        paramCpf = this.state.cpf.toString().replace(/_/g, '');
      }
    }
    this.state.cpf = paramCpf;

    // if (this.state.cpf) {
    this.props.handleSearchFilter(this.state);
    // } else {
    // trataMensagensErro(['Escolha pelo menos um filtro de CPF para a consulta.']);
    // }
  }

  montaFiltroCtc = () => (
    <div className="row">
      <Grid cols="2 2 2 2">
        <Input
          cpf
          integer
          label="CPF"
          mask={Masks.cpf}
          onChange={e => this.handleChange(e, 'cpf')}
          onKeyDown={e => this.handleKeyDown(e, 'cpf')}
          showMask
          value={this.state.cpf}
          // validationState="active"
          // required
        />
      </Grid>
      <Grid cols="3 3 3 3">
        <Input
          label="Situação"
          name="versaoAtiva"
          onChange={e => this.handleChange(e, 'versaoAtiva')}
          itemList={situacaoCTC}
          radio
          value={this.state.versaoAtiva}
          validationState="active"
          custom
        />
      </Grid>
    </div>
  )

  montaFiltros = () => {
    if (this.props.tipoConsulta) {
      return this.montaFiltroCtc();
    }
    return null;
  }

  render() {
    const filtrosPesquisa = this.montaFiltros();
    if (!filtrosPesquisa) {
      return null;
    }
    return (
      <DtpAccordionGroup>
        <DtpAccordionPanel
          headingId="pesquisa"
          panelId="filtro-pesquisa"
          icon="ico-filter"
          title="Filtro de Pesquisa"
        >
          {filtrosPesquisa}
          <div className="row">
            <Button
              className="dtp-primary right"
              title="Pesquisar"
              onClick={() => this.handleSearchButton()}
              hint="Pesquisar de acordo com o filtro aplicado"
            />
          </div>
        </DtpAccordionPanel>
      </DtpAccordionGroup>
    );
  }
}

FiltroRepositorioCtc.propTypes = {
  handleChangeList: PropTypes.func,
  handleSearchFilter: PropTypes.func,
  handleChange: PropTypes.func,
  tipoConsulta: PropTypes.string,
  auth: PropTypes.objectOf(PropTypes.object).isRequired,
}.isRequired;

export default FiltroRepositorioCtc;



// WEBPACK FOOTER //
// ./src/pages/repositorio-ctc/FiltroRepositorioCtc.jsx